module.exports = __webpack_public_path__ + "img/Slow_brand_logo.b285d8de.png";